import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
//import './Login.css';

const Login = ({ apiBaseUrl }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { refreshAuth } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch(`${apiBaseUrl}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || 'Login failed');
      }

      refreshAuth(); // Update auth state after login
      
      // Redirect to the page they were on before login, or default to SteamGame list
      const redirectPath = sessionStorage.getItem('redirectAfterLogin') || '/media-list/SteamGame';
      sessionStorage.removeItem('redirectAfterLogin'); // Clear after use
      navigate(redirectPath);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-background">
      <div className="login-panel">
        <h2>Login</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <label htmlFor="username">Username</label>
          <input
            type="text"
            id="username"
            name="username"
            className="input-field"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            className="input-field"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit" className="btn btn-primary">
            <img src="/static/icons/right-to-bracket-solid.svg" className="icon" alt="Login" /> Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;